import { ForgeChatMessage, ForgeChatMessageSender, ForgeChatMessageSenderType, ForgeChatThread, } from "@supernova-studio/model";
import { z } from "zod";
export const DTOForgeChatMessage = ForgeChatMessage;
export const DTOForgeChatThread = ForgeChatThread;
export const DTOForgeChatMessageSenderType = ForgeChatMessageSenderType;
export const DTOForgeChatMessageSender = ForgeChatMessageSender;
/**
 * POST /api/v1/workspaces/{wsId}/forge/chat-threads
 */
export const DTOForgeChatThreadCreateInput = z.object({
    title: z.string().optional(),
});
/**
 * POST /api/v1/workspaces/{wsId}/forge/threads
 */
export const DTOForgeChatThreadCreateResponse = z.object({
    thread: DTOForgeChatThread,
});
/**
 * PUT /api/v1/workspaces/{wsId}/forge/threads/{threadId}
 */
export const DTOForgeChatThreadUpdateInput = z.object({
    title: z.string(),
});
/**
 * PUT /api/v1/workspaces/{wsId}/forge/threads/{threadId}
 */
export const DTOForgeChatThreadUpdateResponse = z.object({
    thread: DTOForgeChatThread,
});
/**
 * DELETE /api/v1/workspaces/{wsId}/forge/threads/{threadId}
 */
export const DTOForgeChatThreadDeleteResponse = z.object({
    success: z.boolean(),
});
/**
 * GET /api/v1/workspaces/{wsId}/forge/threads
 */
export const DTOForgeChatThreadListQuery = z.object({
    limit: z.number().optional(),
    offset: z.number().optional(),
});
/**
 * GET /api/v1/workspaces/{wsId}/forge/threads
 */
export const DTOForgeChatThreadListResponse = z.object({
    threads: z.array(DTOForgeChatThread),
    pagination: z.object({
        offset: z.number(),
        limit: z.number(),
        total: z.number(),
    }),
});
/**
 * POST /api/v1/workspaces/{wsId}/forge/threads/{threadId}/messages
 */
export const DTOForgeChatMessageCreateInput = z.object({
    payload: z.string(),
    sender: DTOForgeChatMessageSender.optional(),
});
/**
 * POST /api/v1/workspaces/{wsId}/forge/threads/{threadId}/messages
 */
export const DTOForgeChatMessageCreateResponse = z.object({
    message: DTOForgeChatMessage,
});
/**
 * GET /api/v1/workspaces/{wsId}/forge/threads/{threadId}/messages
 */
export const DTOForgeChatMessageListQuery = z.object({
    limit: z
        .string()
        .optional()
        .transform((val) => (val ? parseInt(val, 10) : undefined)),
    offset: z
        .string()
        .optional()
        .transform((val) => (val ? parseInt(val, 10) : undefined)),
});
/**
 * GET /api/v1/workspaces/{wsId}/forge/threads/{threadId}/messages
 */
export const DTOForgeChatMessageListResponse = z.object({
    messages: z.array(DTOForgeChatMessage),
    totalCount: z.number(),
    hasMore: z.boolean(),
});
export const DTOForgeChatExportResponse = z.object({
    csvDownloadUrl: z.string().nullable(),
});
export const DTOForgeChatMessageScoreInput = z.object({
    messageId: z.string(),
    name: z.string(),
    value: z.number(),
    categoryName: z.string().optional(),
    reason: z.string().optional(),
});
export const DTOForgeChatMessageTagInput = z.object({
    messageId: z.string(),
    tags: z.array(z.string()),
});
export const DTOForgeChatMessageScoreRequest = z.object({
    scores: DTOForgeChatMessageScoreInput.array(),
    tags: DTOForgeChatMessageTagInput.array().optional().default([]),
});
